import { api } from '@/lib/api';

/* ── Wilayah ──────────────────────────────────────────────────────────── */

export type RegionLevel = 'province' | 'city' | 'village';

export interface Region {
  id: string;
  parentId: string | null;
  level: RegionLevel;
  name: string;
  code: string | null;
}

export const LEVEL_LABEL: Record<RegionLevel, string> = {
  province: 'Provinsi',
  city: 'Kabupaten',
  village: 'Desa/Nagari',
};

/** Tingkat di bawah sebuah level — null berarti sudah paling dalam. */
export const CHILD_LEVEL: Record<RegionLevel, RegionLevel | null> = {
  province: 'city',
  city: 'village',
  village: null,
};

/* ── Pengguna ─────────────────────────────────────────────────────────── */

export type Role = 'super_admin' | 'assessor' | 'tbm_manager' | 'pelita';

export const ROLE_LABEL: Record<Role, string> = {
  super_admin: 'Super Admin',
  assessor: 'Assessor / Monev',
  tbm_manager: 'Pengelola TBM',
  pelita: 'Individu PELITA SLI',
};

export interface AppUser {
  id: string;
  email: string | null;
  username: string;
  name: string;
  phone: string | null;
  role: Role;
  individualId?: string | null;
  isActive: boolean;
  createdAt: string;
  assignments: { tbmId: string; code: string; name: string }[];
}

export interface UserInput {
  name: string;
  email?: string | null;
  username: string;
  phone: string | null;
  role: Role;
  individualId?: string | null;
  password?: string;
  isActive?: boolean;
}

export const settingsApi = {
  listRegions: (params?: { level?: RegionLevel; parentId?: string }) => {
    const search = new URLSearchParams();
    if (params?.level) search.set('level', params.level);
    if (params?.parentId) search.set('parentId', params.parentId);
    return api.get<Region[]>(`/regions?${search}`);
  },
  createRegion: (body: { parentId: string | null; level: RegionLevel; name: string }) =>
    api.post<Region>('/regions', body),
  updateRegion: (id: string, body: { name: string }) => api.patch(`/regions/${id}`, body),
  deleteRegion: (id: string) => api.del(`/regions/${id}`),

  listUsers: () => api.get<AppUser[]>('/users'),
  createUser: (body: UserInput) => api.post<AppUser>('/users', body),
  updateUser: (id: string, body: Partial<UserInput>) => api.patch(`/users/${id}`, body),
  deleteUser: (id: string) => api.del(`/users/${id}`),
  setAssignments: (id: string, tbmIds: string[]) =>
    api.put(`/users/${id}/assignments`, { tbmIds }),
  resetPassword: (id: string) =>
    api.post<{ success: boolean; message: string; username: string }>(`/users/${id}/reset-password`),
  syncPelitaAccounts: () =>
    api.post<{ created: number; skipped: number; total: number }>('/users/sync-pelita-accounts'),
};
